export default {"src":"/_next/static/media/youtube.9a93ad91.svg","height":26,"width":26};